export const translations = {
  en: {
    home: "Home",
    projects: "Projects",
    contact: "Contact",
    brand_name: "AMFAPPS",
    language_switcher: "Language",
    language_names: { en: "English", es: "Español" },
    chat_with_ai: "Chat with my AI assistant",
    download_cv: "Download my CV",
    get_in_touch: "Get in Touch",
    back_to_projects: "Back to Projects",
    previous: "Previous",
    next: "Next",
    view_live_site: "View Live Site",
    view_repository: "View Repository",
    footer_text: "© {year} Andres Franco. All rights reserved.",
    hero_tagline: "Transforming data into actionable insights with cutting-edge technology and creative solutions",
    years_label: "Years",
    // Project Details Page
    project_overview: "Project Overview",
    skills_technologies: "Skills & Technologies",
    project_details: "Project Details",
    date_label: "Date",
    category_label: "Category",
    view_full_details: "View Full Details",
    project_not_found: "Project not found",
    loading_project: "Loading project data...",
    project_unavailable: "Project data unavailable",
    close: "Close",
    back_to_home: "Back to Home",
    years_experience: "Years of Experience",
    experience_overview: "Experience Overview",
    loading_experience: "Loading experience details...",
    skill_level: "Skill Level",
    // Contact Component Labels
    github: "GitHub",
    linkedin: "LinkedIn",
    twitter: "Twitter",
    contact_form: "Contact Form",
    // Contact Page Labels
    contact_page_description: "Have a question or want to work together? Feel free to reach out!",
    name_label: "Name",
    email_label: "Email",
    subject_label: "Subject",
    message_label: "Message",
    send_message_button: "Send Message",
    sending_button: "Sending...",
    connect_with_me: "Connect With Me",
    // Form Validation Messages
    validation_name_required: "Please enter your name",
    validation_name_min_length: "Name must be at least 2 characters",
    validation_email_required: "Please enter your email address",
    validation_email_invalid: "Please enter a valid email address",
    validation_subject_required: "Please enter a subject",
    validation_subject_min_length: "Subject must be at least 3 characters",
    validation_message_required: "Please enter your message",
    validation_message_min_length: "Message must be at least 10 characters",
    // Delete Section Dialog
    delete_section_title: "Delete Section",
    delete_section_message: "Are you sure you want to delete this section? It will be permanently deleted in all languages and cannot be undone.",
    delete_section_confirm: "Delete",
    delete_section_cancel: "Cancel",
    // Remove Experience Dialog
    remove_experience_title: "Remove Experience",
    remove_experience_prefix: "Are you sure you want to remove",
    remove_experience_message: "from your portfolio? This will not delete the experience permanently, only remove it from this portfolio.",
    remove_experience_confirm: "Remove",
    remove_experience_cancel: "Cancel"
  },
  es: {
    home: "Inicio",
    language_switcher: "Idioma",
    language_names: { en: "Inglés", es: "Español" },
    projects: "Proyectos",
    contact: "Contacto",
    brand_name: "AMFAPPS",
    chat_with_ai: "Chatea con mi asistente de IA",
    download_cv: "Descargar mi CV",
    get_in_touch: "Contáctame",
    back_to_projects: "Volver a Proyectos",
    previous: "Anterior",
    next: "Siguiente",
    view_live_site: "Ver Sitio en Vivo",
    view_repository: "Ver Repositorio",
    footer_text: "© {year} Andres Franco. Todos los derechos reservados.",
    hero_tagline: "Transformando datos en perspectivas accionables con tecnología de vanguardia y soluciones creativas",
    years_label: "Años",
    // Project Details Page
    project_overview: "Descripción del Proyecto",
    skills_technologies: "Habilidades y Tecnologías",
    project_details: "Detalles del Proyecto",
    date_label: "Fecha",
    category_label: "Categoría",
    view_full_details: "Ver Detalles Completos",
    project_not_found: "Proyecto no encontrado",
    loading_project: "Cargando datos del proyecto...",
    project_unavailable: "Datos del proyecto no disponibles",
    close: "Cerrar",
    back_to_home: "Volver al Inicio",
    years_experience: "Años de Experiencia",
    experience_overview: "Descripción de la Experiencia",
    loading_experience: "Cargando detalles de experiencia...",
    skill_level: "Nivel de Habilidad",
    // Contact Component Labels
    github: "GitHub",
    linkedin: "LinkedIn",
    twitter: "Twitter",
    contact_form: "Formulario de Contacto",
    // Contact Page Labels
    contact_page_description: "¿Tienes alguna pregunta o quieres que trabajemos juntos? ¡No dudes en contactarme!",
    name_label: "Nombre",
    email_label: "Correo Electrónico",
    subject_label: "Asunto",
    message_label: "Mensaje",
    send_message_button: "Enviar Mensaje",
    sending_button: "Enviando...",
    connect_with_me: "Conéctate Conmigo",
    // Form Validation Messages
    validation_name_required: "Por favor ingresa tu nombre",
    validation_name_min_length: "El nombre debe tener al menos 2 caracteres",
    validation_email_required: "Por favor ingresa tu correo electrónico",
    validation_email_invalid: "Por favor ingresa un correo electrónico válido",
    validation_subject_required: "Por favor ingresa un asunto",
    validation_subject_min_length: "El asunto debe tener al menos 3 caracteres",
    validation_message_required: "Por favor ingresa tu mensaje",
    validation_message_min_length: "El mensaje debe tener al menos 10 caracteres",
    // Delete Section Dialog
    delete_section_title: "Eliminar Sección",
    delete_section_message: "¿Estás seguro de que deseas eliminar esta sección? Se eliminará permanentemente en todos los idiomas y no se puede deshacer.",
    delete_section_confirm: "Eliminar",
    delete_section_cancel: "Cancelar",
    // Remove Experience Dialog
    remove_experience_title: "Eliminar Experiencia",
    remove_experience_prefix: "¿Estás seguro de que deseas eliminar",
    remove_experience_message: "de tu portafolio? Esto no eliminará la experiencia permanentemente, solo la eliminará de este portafolio.",
    remove_experience_confirm: "Eliminar",
    remove_experience_cancel: "Cancelar"
  }
};